import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";
import { IconButton } from "@mui/material";
import { useMediaQuery } from "@mui/material";

interface CustomDialogProps {
  component: React.ReactNode;
  title: string;
  openDialog: boolean;
  handleCloseDialog?: () => void;
  maxWidth?: "xs" | "sm" | "md" | "lg" | "xl" | false;
  modalPlace?: "center" | "right" | "left"; 
  // New prop to control modal placement
}

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
    height: "calc(100% - 64px)", // Full height minus title and close button
    overflowY: "auto",
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const CustomDialog: React.FC<CustomDialogProps> = ({
  component,
  title,
  openDialog,
  handleCloseDialog,
  maxWidth = "sm",
  modalPlace = "center", // Default placement is center
}) => {
  const isLogin = title === "Login";
  const isfromLoadingPopup = title === "loadingPopup";
  const isLargeScreen = useMediaQuery("(min-width:560px)");
  return (
    <React.Fragment>
      <BootstrapDialog
        maxWidth={isLogin ? "xl" : maxWidth} // Large width for Login, default for others
        fullWidth={isLogin}
        onClose={handleCloseDialog}
        TransitionComponent={Transition}
        keepMounted
        aria-labelledby="customized-dialog-title"
        open={openDialog}
        PaperProps={{
          style: {
            minHeight: modalPlace === "center" ? "auto" : "100vh",
          },
          sx: {
            position: "fixed",
            top: modalPlace === "center" ? "50%" : 0,
            left:
              modalPlace === "center"
                ? "50%"
                : modalPlace === "left"
                ? 0
                : "unset",
            right: modalPlace === "right" ? 0 : "unset",
            transform:
              modalPlace === "center" ? "translate(-50%, -50%)" : "none", // Centering logic
            height:
              modalPlace === "right" || modalPlace === "left"
                ? "100vh"
                : "auto", // Full height if right or left
            width: isLogin
              ? "50%" // Explicit large width for Login
              : modalPlace === "right" || modalPlace === "left"
              ? "40vh" // Fixed width for side modals
              : "auto", // Default auto width

            minWidth: isLargeScreen
              ? "400px"
              : title === "Login"
              ? "300px"
              : "auto",
            maxWidth:
              title === "Quick Add" && !isLargeScreen ? "300px" : "auto",
            margin: 0,
            display: "flex",
            flexDirection: "column",
          },
        }}
      >
        {!isfromLoadingPopup && 
        <DialogTitle
          sx={{ m: title ? 0 : 1, p: 2 }}
          style={{
            margin: isLogin ? "0px 0px 20x" : "",
            paddingLeft: isLogin ? "37px" : "",
            fontSize: isLogin ? "28px" : "18px",
            fontFamily: isLogin ? "Albert Sans, sans-serif" : "",
            // paddingRight: "50px",
          }}
        >
          {title}
          <IconButton
            aria-label="close"
            onClick={handleCloseDialog}
            sx={{
              position: "absolute",
              right: isLogin ? 22 : 8,
              top: isLogin ? 18 : 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
           }
        <DialogContent dividers sx={{ flexGrow: 1 }}>
          {component}
        </DialogContent>
      
      </BootstrapDialog>
    </React.Fragment>
  );
};

export default CustomDialog;
